(function () {
  'use strict';

  var root = document.querySelector('[data-yari]');
  var cfgEl = document.getElementById('YariConfig');
  if (!root || !cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var bubble = root.querySelector('[data-yari-toggle]');
  var panel = root.querySelector('[data-yari-panel]');
  var log = root.querySelector('[data-yari-log]');
  var actions = root.querySelector('[data-yari-actions]');
  var hint = root.querySelector('[data-yari-hint]');
  var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var DIRHAM = '<svg class="dirham" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7 3.5h4.5a8.5 8.5 0 0 1 0 17H7z" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linejoin="round"/><path d="M2.5 10h17.5M2.5 14h17.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';

  var state = {};
  var catalog = null;
  var started = false;

  function storeGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function storeSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined && text !== null) n.textContent = text;
    return n;
  }
  function priceHTML(amount) {
    var num = Number(amount);
    var s = num % 1 === 0 ? String(num) : num.toFixed(2);
    var parts = s.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '<span class="price-amount">' + DIRHAM + '<span class="visually-hidden">AED </span>' + parts.join('.') + '</span>';
  }
  function scrollDown() { log.scrollTop = log.scrollHeight; }

  function say(text, delay) {
    return new Promise(function (resolve) {
      var typing = el('div', 'yari__typing');
      typing.innerHTML = '<i></i><i></i><i></i>';
      typing.setAttribute('aria-hidden', 'true');
      log.appendChild(typing);
      scrollDown();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      setTimeout(function () {
        typing.remove();
        log.appendChild(el('div', 'yari__msg yari__msg--bot', text));
        scrollDown();
        resolve();
      }, reduce ? 0 : (delay || 550));
    });
  }
  function me(text) { log.appendChild(el('div', 'yari__msg yari__msg--me', text)); scrollDown(); }

  function chips(list) {
    actions.innerHTML = '';
    list.forEach(function (item) {
      var b = el('button', 'yari__chip' + (item.solid ? ' yari__chip--solid' : '') + (item.ghost ? ' yari__chip--ghost' : ''), item.label);
      b.type = 'button';
      b.addEventListener('click', function () {
        if (!item.silent) me(item.label);
        actions.innerHTML = '';
        item.go();
      });
      actions.appendChild(b);
    });
    var first = actions.querySelector('button');
    if (first && !panel.hidden) first.focus({ preventScroll: true });
  }

  // ---------- Catalogue ----------
  function loadCatalog() {
    if (catalog) return Promise.resolve(catalog);
    return fetch(base + 'products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        catalog = (data.products || []).filter(function (p) {
          var tags = (Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',')).map(function (t) { return t.trim().toLowerCase(); });
          p._tags = tags;
          return tags.indexOf('add-on') === -1 && p.variants.some(function (v) { return v.available; });
        });
        return catalog;
      })
      .catch(function () { catalog = []; return catalog; });
  }

  var COLOURS = {
    'Pink & blush': ['pink', 'blush', 'peony', 'coral', 'bubble', 'dragée', 'pétale', 'morganite', 'rhodonite', 'silk'],
    'Red & romantic': ['red', 'rouge', 'velours', 'freedom', 'ruby', 'rubis', 'scarlet', 'burgundy', 'eternal', 'eclipse'],
    'White & soft': ['white', 'ivory', 'cream', 'neige', 'playa', 'novavita', 'perle', 'pearl', 'nacre', 'opale', 'nuage', 'lime'],
    'Colourful': ['blue', 'purple', 'yellow', 'peach', 'orange', 'green', 'lilac', 'dopamine', 'iolite', 'ciel', 'lavender']
  };
  var BUDGETS = {
    'Under 800': [0, 800],
    '800 to 1,500': [800, 1500],
    '1,500 to 2,500': [1500, 2500],
    '2,500 and up': [2500, 1e9],
    'Any budget': [0, 1e9]
  };
  var STYLES = {
    'A bouquet': ['mono bouquet', "author's bouquet", 'bouquet'],
    'A box': ['box'],
    'A basket': ['basket'],
    'Surprise me': []
  };

  function minPrice(p) {
    // Price of the main size (the arrangement in the photo), same as the shop cards
    if (cfg.prices && cfg.prices[p.handle]) return cfg.prices[p.handle] / 100;
    return Math.min.apply(null, p.variants.filter(function (v) { return v.available; }).map(function (v) { return Number(v.price); }));
  }

  function rank() {
    var words = COLOURS[state.colour] || [];
    var types = STYLES[state.style] || [];
    var range = BUDGETS[state.budget] || [0, 1e9];
    return catalog.map(function (p) {
      var text = (p.title + ' ' + (p.body_html || '') + ' ' + (p.product_type || '')).toLowerCase();
      var score = 0;
      words.forEach(function (w) { if (text.indexOf(w) > -1) score += 3; });
      var type = (p.product_type || '').toLowerCase();
      if (types.length) {
        if (types.some(function (t) { return type === t || (t === 'bouquet' && type.indexOf('bouquet') > -1); })) score += 5;
        else score -= 4;
      }
      var price = minPrice(p);
      if (price >= range[0] && price <= range[1]) score += 6; else score -= 8;
      if (p.images && p.images.length) score += 1;
      return { p: p, score: score, price: price };
    }).sort(function (a, b) { return b.score - a.score || a.price - b.price; });
  }

  function showProducts(list) {
    var wrap = el('div', 'yari__products');
    list.forEach(function (item) {
      var p = item.p;
      var card = el('div', 'yari__product');
      var img = document.createElement('img');
      img.alt = '';
      img.loading = 'lazy';
      if (p.images && p.images[0]) img.src = p.images[0].src.replace(/(\.[a-z]+)(\?|$)/i, '_300x$1$2');
      card.appendChild(img);
      var info = el('div');
      info.appendChild(el('div', 'yari__product-name', p.title));
      var price = el('div', 'yari__product-price');
      var bpos = boxPos(p);
      var varies = p.variants.filter(function (v) { return bpos < 0 || optVal(v, bpos) === 'No box'; }).some(function (v) { return Number(v.price) !== item.price; });
      price.innerHTML = (varies ? 'From ' : '') + priceHTML(item.price);
      info.appendChild(price);
      var btns = el('div', 'yari__product-btns');
      var view = el('a', null, 'View');
      view.href = base + 'products/' + p.handle;
      var pick = el('button', null, 'Choose this');
      pick.type = 'button';
      pick.addEventListener('click', function () { me('I love ' + p.title); actions.innerHTML = ''; choose(p); });
      btns.appendChild(view);
      btns.appendChild(pick);
      info.appendChild(btns);
      card.appendChild(info);
      wrap.appendChild(card);
    });
    log.appendChild(wrap);
    scrollDown();
  }

  // ---------- Flow ----------
  function menu(intro) {
    var p = intro ? say(intro) : Promise.resolve();
    p.then(function () {
      var list = [
        { label: 'Help me choose flowers', solid: true, go: askOccasion },
        { label: 'I have a question', go: askFaq },
        { label: 'Shop all', go: function () { window.location.href = base + 'collections/all'; } }
      ];
      if (cfg.whatsapp) list.push({ label: 'Talk to a person', ghost: true, go: human });
      chips(list);
    });
  }

  function askOccasion() {
    state = {};
    say("Lovely! What's the occasion?").then(function () {
      var list = (cfg.occasions || []).map(function (o) {
        return { label: o.label, go: function () { state.occasion = o; askColour(); } };
      });
      if (!(cfg.occasions || []).some(function (o) { return /just because/i.test(o.label); })) list.push({ label: 'Just because', go: function () { state.occasion = { label: 'Just because', messages: ['Just because you deserve flowers today.', 'Thinking of you.'] }; askColour(); } });
      chips(list);
    });
  }

  function askColour() {
    say('Which colours feel like them?').then(function () {
      chips(Object.keys(COLOURS).concat(['Surprise me']).map(function (c) {
        return { label: c, go: function () { state.colour = c; askStyle(); } };
      }));
    });
  }

  function askStyle() {
    say('Bouquet, box or basket?').then(function () {
      chips(Object.keys(STYLES).map(function (s) {
        return { label: s, go: function () { state.style = s; askBudget(); } };
      }));
    });
  }

  function askBudget() {
    say("And roughly what's your budget?").then(function () {
      chips(Object.keys(BUDGETS).map(function (b) {
        return { label: b, go: function () { state.budget = b; recommend(0); } };
      }));
    });
  }

  function recommend(offset) {
    var intro = offset ? 'Here are a few more.' : 'Let me look through today’s flowers…';
    say(intro, offset ? 400 : 700).then(loadCatalog).then(function () {
      if (!catalog.length) {
        return say("I couldn't load our flowers just now. You can browse them all, or message us and we'll help.").then(function () {
          chips([{ label: 'Shop all', go: function () { window.location.href = base + 'collections/all'; } }].concat(cfg.whatsapp ? [{ label: 'Talk to a person', go: human }] : []));
        });
      }
      var ranked = rank();
      var slice = ranked.slice(offset, offset + 3);
      if (!slice.length) {
        return say("That's everything that matches. Want to try different choices?").then(function () {
          chips([{ label: 'Start again', solid: true, go: askOccasion }, { label: 'Shop all', go: function () { window.location.href = base + 'collections/all'; } }]);
        });
      }
      return say(offset ? 'What about these?' : 'I think they’d love one of these:', 300).then(function () {
        showProducts(slice);
        var list = [];
        if (ranked.length > offset + 3) list.push({ label: 'Show me more', go: function () { recommend(offset + 3); } });
        list.push({ label: 'Change my answers', ghost: true, go: askOccasion });
        chips(list);
      });
    });
  }

  function boxPos(p) {
    var i = -1;
    (p.options || []).forEach(function (o, n) { if (o.name === 'Box') i = n; });
    return i;
  }
  function optVal(v, i) { return v['option' + (i + 1)]; }
  function baseLabel(p, v) {
    var bp = boxPos(p);
    if (bp < 0) return v.title;
    var parts = [];
    for (var i = 0; i < (p.options || []).length; i++) { if (i !== bp) parts.push(optVal(v, i)); }
    return parts.join(' / ');
  }

  function choose(p) {
    state.product = p;
    var bp = boxPos(p);
    var available = p.variants.filter(function (v) { return v.available && (bp < 0 || optVal(v, bp) === 'No box'); });
    if (!available.length) available = p.variants.filter(function (v) { return v.available; });
    if (available.length > 1) {
      say('Beautiful choice. Which one?').then(function () {
        chips(available.map(function (v) {
          return { label: baseLabel(p, v) + ' · ' + Number(v.price).toLocaleString('en-US') , go: function () { state.variant = v; askCard(); } };
        }));
      });
    } else {
      state.variant = available[0];
      say('Beautiful choice, ' + p.title + ' it is.').then(askCard);
    }
  }

  function askCard() {
    if (!cfg.showCard) return askBox();
    say('Shall we add a card? Here are some ideas, or write your own.').then(function () {
      var ideas = ((state.occasion && state.occasion.messages) || []).map(function (m) { return m.trim(); }).filter(Boolean).slice(0, 4);
      var list = ideas.map(function (m) { return { label: m, go: function () { state.card = m; askFont(); } }; });
      list.push({ label: 'Write my own', solid: true, go: writeCard });
      list.push({ label: 'No card', ghost: true, go: function () { state.card = ''; state.cardFont = ''; state.cardAlign = ''; askBox(); } });
      chips(list);
    });
  }

  function writeCard() {
    say('Type your message below (up to 250 characters).').then(function () {
      actions.innerHTML = '';
      var wrap = el('div', 'yari__input');
      var label = el('label', 'visually-hidden', 'Card message');
      label.htmlFor = 'YariCard';
      var area = document.createElement('textarea');
      area.id = 'YariCard';
      area.maxLength = 250;
      area.placeholder = 'Happy birthday, with love';
      var send = el('button', 'yari__chip yari__chip--solid', 'Done');
      send.type = 'button';
      send.addEventListener('click', function () {
        var v = area.value.trim();
        if (!v) { area.focus(); return; }
        state.card = v;
        me(v);
        actions.innerHTML = '';
        askFont();
      });
      wrap.appendChild(label); wrap.appendChild(area); wrap.appendChild(send);
      actions.appendChild(wrap);
      area.focus();
    });
  }

  function askFont() {
    var fonts = [
      { label: 'Classic', css: "'Cormorant Garamond', serif" },
      { label: 'Script', css: "'Great Vibes', cursive" },
      { label: 'Handwritten', css: "'Caveat', cursive" },
      { label: 'Modern', css: "'Jost', sans-serif" }
    ];
    say('Which writing style for your card?').then(function () {
      chips(fonts.map(function (f) { return { label: f.label, go: function () { state.cardFont = f.label; askAlign(); } }; }));
      Array.prototype.forEach.call(actions.querySelectorAll('button'), function (b, i) { if (fonts[i]) b.style.fontFamily = fonts[i].css; });
    });
  }

  function askAlign() {
    say('And how should the text sit on the card?').then(function () {
      chips(['Left', 'Center', 'Right'].map(function (a) { return { label: a, go: function () { state.cardAlign = a; askBox(); } }; }));
    });
  }

  function boxOptions() {
    return String(cfg.boxOptions || '').split(/\n/).map(function (l) { return l.split('|')[0].trim(); }).filter(Boolean);
  }

  function askBox() {
    var opts = boxOptions();
    state.box = '';
    if (state.product._tags.indexOf('no-box-choice') > -1) return askAddons();
    var isBox = (state.product.product_type || '').toLowerCase() === 'box';
    if (isBox) {
      if (!opts.length) return askAddons();
      return say('Which box colour?').then(function () {
        chips(opts.map(function (o) { return { label: o, go: function () { state.box = o; askAddons(); } }; }));
      });
    }
    var bp = boxPos(state.product);
    if (bp < 0) return askAddons();
    var baseV = state.variant;
    var ups = state.product.variants.filter(function (v) {
      if (!v.available || optVal(v, bp) === 'No box') return false;
      for (var i = 0; i < state.product.options.length; i++) {
        if (i !== bp && optVal(v, i) !== optVal(baseV, i)) return false;
      }
      return true;
    });
    if (!ups.length) return askAddons();
    var diff = Math.round((Number(ups[0].price) - Number(baseV.price)) * 100) / 100;
    say('Would you like it in our signature box?' + (diff > 0 ? ' It’s +' + diff + ' AED.' : '')).then(function () {
      var list = ups.map(function (v) {
        return { label: optVal(v, bp), go: function () { state.variant = v; askAddons(); } };
      });
      list.push({ label: 'No box, thanks', ghost: true, go: function () { askAddons(); } });
      chips(list);
    });
  }

  function askAddons() {
    if (!cfg.addonsHandle) return askDate();
    fetch(base + 'collections/' + cfg.addonsHandle + '/products.json?limit=12')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var addons = (data.products || []).filter(function (p) { return (p.tags || []).indexOf('box-upgrade') === -1 && p.variants.some(function (v) { return v.available; }); });
        if (!addons.length) return askDate();
        state.addons = [];
        return say('Want to make it extra? Tap to add, then Done.').then(function () {
          actions.innerHTML = '';
          addons.forEach(function (a) {
            var v = a.variants.filter(function (x) { return x.available; })[0];
            var b = el('button', 'yari__chip');
            b.type = 'button';
            b.setAttribute('aria-pressed', 'false');
            b.innerHTML = '';
            b.appendChild(document.createTextNode(a.title + ' + '));
            var pr = el('span'); pr.innerHTML = priceHTML(v.price); b.appendChild(pr);
            b.addEventListener('click', function () {
              var i = state.addons.indexOf(v.id);
              if (i > -1) { state.addons.splice(i, 1); b.classList.remove('yari__chip--solid'); b.setAttribute('aria-pressed', 'false'); }
              else { state.addons.push(v.id); state.addonNames = (state.addonNames || []).concat(a.title); b.classList.add('yari__chip--solid'); b.setAttribute('aria-pressed', 'true'); }
            });
            actions.appendChild(b);
          });
          var done = el('button', 'yari__chip yari__chip--solid', 'Done');
          done.type = 'button';
          done.style.width = '100%';
          done.addEventListener('click', function () { me(state.addons.length ? 'Added extras' : 'No extras'); actions.innerHTML = ''; askDate(); });
          actions.appendChild(done);
        });
      })
      .catch(askDate);
  }

  function askDate() {
    if (!cfg.showDate) return confirmOrder();
    say('When should it arrive?').then(function () {
      actions.innerHTML = '';
      var wrap = el('div', 'yari__input');
      var label = el('label', 'visually-hidden', 'Delivery date');
      label.htmlFor = 'YariDate';
      var input = document.createElement('input');
      input.type = 'date';
      input.id = 'YariDate';
      var d = new Date();
      input.min = new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
      var ok = el('button', 'yari__chip yari__chip--solid', 'Done');
      ok.type = 'button';
      ok.addEventListener('click', function () {
        if (!input.value) { input.focus(); return; }
        state.date = input.value;
        me(new Date(input.value + 'T12:00:00').toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long' }));
        actions.innerHTML = '';
        confirmOrder();
      });
      wrap.appendChild(label); wrap.appendChild(input); wrap.appendChild(ok);
      actions.appendChild(wrap);
      var skip = el('button', 'yari__chip yari__chip--ghost', "I'll choose at checkout");
      skip.type = 'button';
      skip.addEventListener('click', function () { me(skip.textContent); actions.innerHTML = ''; confirmOrder(); });
      actions.appendChild(skip);
    });
  }

  function confirmOrder() {
    var vt = state.variant ? state.variant.title.replace(/ \/ No box$|^No box$/, '') : '';
    var lines = [state.product.title + (vt && vt !== 'Default Title' ? ' (' + vt + ')' : '')];
    if (state.box) lines.push('Box: ' + state.box);
    if (state.card) lines.push('Card: “' + state.card + '”' + (state.cardFont ? ' (' + state.cardFont + (state.cardAlign ? ', ' + state.cardAlign.toLowerCase() : '') + ')' : ''));
    if (state.date) lines.push('Delivery: ' + state.date);
    if (state.addons && state.addons.length) lines.push('Extras: ' + state.addons.length);
    say('Here’s your order:\n' + lines.join('\n')).then(function () {
      chips([
        { label: 'Add to bag', solid: true, go: addToBag },
        { label: 'Change something', ghost: true, go: askOccasion }
      ]);
    });
  }

  function addToBag() {
    var props = {};
    if (state.box) props[cfg.boxLabel || 'Box colour'] = state.box;
    if (state.card) {
      props['Card message'] = state.card;
      if (state.cardFont) props['Card font'] = state.cardFont;
      if (state.cardAlign) props['Card alignment'] = state.cardAlign;
    }
    if (state.date) props['Delivery date'] = state.date;
    var items = [{ id: state.variant.id, quantity: 1, properties: props }];
    (state.addons || []).forEach(function (id) { items.push({ id: id, quantity: 1, properties: { '_For': state.product.title } }); });
    say('Wrapping it up…', 300).then(function () {
      return fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      });
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.d.description || 'error');
        updateBagCount();
        return say("It's in your bag! Ready to check out?").then(function () {
          chips([
            { label: 'Checkout', solid: true, go: function () { window.location.href = base + 'checkout'; } },
            { label: 'View bag', go: function () { window.location.href = base + 'cart'; } },
            { label: 'Find another gift', ghost: true, go: askOccasion }
          ]);
        });
      })
      .catch(function () {
        say("Sorry, that didn't work. Please try again, or message us and we'll sort it.").then(function () {
          chips([{ label: 'Try again', solid: true, go: addToBag }].concat(cfg.whatsapp ? [{ label: 'Talk to a person', go: human }] : []));
        });
      });
  }

  function updateBagCount() {
    fetch(base + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('.bag-btn').forEach(function (b) {
        b.setAttribute('aria-label', 'Bag, ' + c.item_count + ' items');
        var last = b.lastChild;
        if (last && last.nodeType === 3) last.textContent = ' Bag · ' + c.item_count;
      });
    }).catch(function () {});
  }

  function askFaq() {
    var faqs = cfg.faqs || [];
    if (!faqs.length) return human();
    say('Of course. What would you like to know?').then(function () {
      var list = faqs.map(function (f) {
        return { label: f.q, go: function () { say(f.a).then(function () { afterFaq(); }); } };
      });
      if (cfg.whatsapp) list.push({ label: 'Something else', ghost: true, go: human });
      chips(list);
    });
  }
  function afterFaq() {
    chips([
      { label: 'Another question', go: askFaq },
      { label: 'Help me choose flowers', solid: true, go: askOccasion }
    ].concat(cfg.whatsapp ? [{ label: 'Talk to a person', ghost: true, go: human }] : []));
  }

  function human() {
    say('Our team is happy to help on WhatsApp.').then(function () {
      actions.innerHTML = '';
      var a = el('a', 'yari__chip yari__chip--solid', 'Open WhatsApp');
      a.href = 'https://wa.me/' + cfg.whatsapp + '?text=' + encodeURIComponent('Hi yarímè., I need help with an order.');
      a.target = '_blank';
      a.rel = 'noopener';
      a.style.display = 'inline-flex';
      a.style.alignItems = 'center';
      actions.appendChild(a);
      var back = el('button', 'yari__chip yari__chip--ghost', 'Back');
      back.type = 'button';
      back.addEventListener('click', function () { actions.innerHTML = ''; menu(); });
      actions.appendChild(back);
    });
  }

  // ---------- Open / close ----------
  function open() {
    panel.hidden = false;
    bubble.setAttribute('aria-expanded', 'true');
    if (hint) hint.hidden = true;
    storeSet('yari-seen', '1');
    if (!started) { started = true; menu(cfg.greeting); loadCatalog(); }
    else { var f = actions.querySelector('button, textarea, input, a'); if (f) f.focus({ preventScroll: true }); }
  }
  function close() {
    panel.hidden = true;
    bubble.setAttribute('aria-expanded', 'false');
    bubble.focus();
  }
  bubble.addEventListener('click', function () { if (panel.hidden) open(); else close(); });
  root.querySelector('[data-yari-close]').addEventListener('click', close);
  root.querySelector('[data-yari-restart]').addEventListener('click', function () {
    log.innerHTML = '';
    actions.innerHTML = '';
    state = {};
    menu(cfg.greeting);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });

  if (hint && !storeGet('yari-seen')) {
    setTimeout(function () { if (panel.hidden) hint.hidden = false; }, (Number(cfg.autoHint) || 8) * 1000);
    hint.addEventListener('click', open);
  }
})();
